// Created by jarongallo at 6/9/21
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_SERVICE_REQUEST_INCORRECT } from './queries';
import FullscreenFiles from '../../IndividualService/FullscreenFiles';
import { FULLSCREEN_TYPES } from '../../IndividualService/FullscreenFiles/config';

export default function ServiceRequestIncorrectTab({ serviceRequestId }: ServiceRequestIncorrectTabProps) {
	const [selectedRequestedFileIndex, setSelectedRequestedFileIndex] = useState<number | undefined>(undefined);
	const [requestedFiles, setRequestedFiles] = useState<FileType[] | undefined>([]);
	const [service, setService] = useState<ServiceType>();

	const [getServiceRequestIncorrect, { data: serviceRequestData }] = useLazyQuery(GET_SERVICE_REQUEST_INCORRECT, {
		variables: { id: serviceRequestId }
	});

	useEffect(() => {
		(async () => {
			await getServiceRequestIncorrect();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (serviceRequestData) {
				setService(serviceRequestData.serviceRequest.service);
				setRequestedFiles(serviceRequestData.serviceRequest.requestedFiles);
			}
		})();
	}, [serviceRequestData]);

	if (!requestedFiles) return null;

	return (
		<div>
			{selectedRequestedFileIndex !== undefined && (
				<FullscreenFiles
					type={FULLSCREEN_TYPES.IMAGE_TYPE}
					updateService={() => getServiceRequestIncorrect}
					initialSlide={selectedRequestedFileIndex}
					goBack={() => setSelectedRequestedFileIndex(undefined)}
					files={requestedFiles}
					service={service}
				/>
			)}
			{requestedFiles &&
				requestedFiles.map((requestedFile, index) => (
					<img
						key={requestedFile.id}
						onClick={() => setSelectedRequestedFileIndex(index)}
						className='uiServiceRequest--thumbnail'
						alt={requestedFile.filename}
						src={requestedFile['webUrl']}
					/>
				))}
		</div>
	);
}
